module.exports = __webpack_public_path__ + "fonts/fontawesome-webfont.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fontawesome-webfont.woff2?v=4.7.0
// module id = 60
// module chunks = 0